import React from 'react';
import styled from 'styled-components';

import { useSelectorActiveChain } from '#/components/hooks';

import polygonPoSImage from './chainPolygon.png';
import etherscanImage from './etherscan_dark.png';
import katanaImage from './katana.png';

const Image = styled.img`
  width: ${({ width }) => width};
  margin: -3px 0;

  &:hover {
    filter: brightness(0.6);
  }
`;

export default function ChainExplorerIcon({
  size = '19px',
}: {
  size?: string;
}) {
  const { activeChain } = useSelectorActiveChain();
  return activeChain === 'katanaEVMChain' ? (
    <Image src={katanaImage} width={size} alt="KATANA" />
  ) : activeChain === 'polygonPoSChain' ? (
    <Image src={polygonPoSImage} width={size} alt="Polygon PoS" />
  ) : (
    <Image src={etherscanImage} width={size} alt="BlockExplorer" />
  );
}
